var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1251 29.4139C23.167 29.4139 29.6863 22.8946 29.6863 14.8527C29.6863 6.81077 23.167 0.291504 15.1251 0.291504C7.08315 0.291504 0.563881 6.81077 0.563881 14.8527C0.563881 22.8946 7.08315 29.4139 15.1251 29.4139Z",
    fill: "#3CC0A0",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1252 26.6923C21.6638 26.6923 26.9645 21.3917 26.9645 14.853C26.9645 8.31432 21.6638 3.01367 15.1252 3.01367C8.58648 3.01367 3.28584 8.31432 3.28584 14.853C3.28584 21.3917 8.58648 26.6923 15.1252 26.6923Z",
    fill: "#3CC0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 9.2915C15.2441 9.2915 15.3639 9.37729 15.4388 9.53458C15.903 10.4497 16.3822 11.3505 16.8464 12.2656C16.8764 12.337 16.9213 12.3656 17.0111 12.3799C18.0594 12.5229 19.0926 12.6659 20.1408 12.8089C20.4403 12.8518 20.5901 12.9948 20.5601 13.2235C20.5451 13.3093 20.4852 13.4094 20.4104 13.4809C19.6467 14.1958 18.883 14.9107 18.1193 15.6114C18.0594 15.6686 18.0444 15.7115 18.0594 15.7972C18.2391 16.8124 18.4187 17.8276 18.5984 18.8428C18.6284 19.0001 18.5835 19.1288 18.4487 19.2145C18.3139 19.3146 18.1642 19.3146 18.0144 19.2288C17.071 18.757 16.1276 18.2852 15.1842 17.799C15.0944 17.7561 15.0345 17.7561 14.9596 17.799C14.0312 18.2709 13.0878 18.7427 12.1593 19.2145C12.0246 19.286 11.8898 19.3146 11.7401 19.2431C11.5903 19.1717 11.5154 19.0144 11.5454 18.8571C11.6802 18.0993 11.8149 17.3415 11.9497 16.5694C11.9946 16.2977 12.0545 16.026 12.0994 15.7544C12.0994 15.7115 12.0695 15.6543 12.0396 15.6257C11.3058 14.9536 10.587 14.2959 9.8832 13.6382C9.8233 13.581 9.76341 13.5238 9.68853 13.4666C9.56873 13.3665 9.53879 13.2235 9.58371 13.0806C9.62863 12.9376 9.73346 12.8518 9.89818 12.8232C10.4972 12.7374 11.0961 12.6516 11.6951 12.5801C12.1743 12.5086 12.6385 12.4514 13.1177 12.3799C13.2076 12.3656 13.2525 12.337 13.2824 12.2656C13.7467 11.3505 14.2258 10.4497 14.6901 9.53458C14.7649 9.37729 14.8847 9.2915 15.0195 9.2915Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.2341,
    y1: 25.8574,
    x2: 15.2341,
    y2: 35.9703,
    stroke: "#3CC0A0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMarker);
export default __webpack_public_path__ + "static/media/eventMarker.77c1077eafa6ef5dcde6d29c8bcfbc22.svg";
export { ForwardRef as ReactComponent };